import { Box, Stack, Typography } from "@mui/material";
import EmptyListText from "components/EmptyListText";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Dispatch, SetStateAction} from "react";

interface SubcategoryListProps {
  subcategories: { id: string, title: string }[];
  selectedSubcategory: string;
  setSelectedSubcategory: Dispatch<SetStateAction<string>>;
  onClose?: () => void;
}

const SubcategoryList = ({
                           subcategories,
                           selectedSubcategory,
                           setSelectedSubcategory,
  onClose
                         }: SubcategoryListProps) => {

  const {id} = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const onSelectSubcategory = (subcategoryId: string) => {
    setSelectedSubcategory(subcategoryId);
    onClose?.();
    if (id) {
      navigate(`/${location.pathname.split('/')[1]}`)
    }
  }

  if (!subcategories.length) {
    return <EmptyListText>Нет подкатегорий</EmptyListText>;
  }

  return (
    <Stack sx={{ maxHeight: 200, overflow: 'auto' }}>
      {subcategories.map((subcategory) => (
        <Box
          key={subcategory.id}
          sx={{
            px: 2.5,
            py: 1,
            cursor: 'pointer',
          }}
          onClick={() => onSelectSubcategory(subcategory.id)}
        >
          <Typography variant={'p2'} sx={{
            color: selectedSubcategory === subcategory.id ? 'primary.main' : undefined,
          }}>
            {subcategory.title}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default SubcategoryList;
